import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-00626661"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sticky-column" }
const _hoisted_2 = {
  class: "is-flex is-justify-content-start",
  style: {"gap":"1em"}
}
const _hoisted_3 = { key: 0 }


import { defineComponent, defineProps, onMounted } from 'vue'
import { useStore } from "vuex";
import { Notyf } from "notyf";

const props = defineProps(['fileData'])
const store = useStore()

const notyf = new Notyf()

const __default__ = defineComponent({
  name: "AppointmentDataFileTableRow",
})


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: ['fileData'],
  setup(__props) {


const props = __props
const store = useStore()

const downloadFile = async (fileUrl: string, fileName: string) => {
  // Dispatch the action to the Vuex store for downloading the file
  await store.dispatch('downloadFile', { fileUrl, fileName });
};


function editingAppointment(): boolean {
  console.log(store.getters.getEditingAppointment)
  return (store.getters.getEditingAppointment)
}

const remove = async (fileData: any, $t: any) => {
  if (confirm('Do you want to remove this file?')) {
    //TODO:Create notification to ask if it is really to delete
    console.log("remove")
    console.log(store.getters.getEditedAppointmentFiles)
    if (fileData.file_id != 0) {
      // Store appointment to be deleted in the DB when saving data.
      // Only of it hasn't been added in this interaction
      await store.dispatch('saveFileToBeDeleted', fileData.file_id)
    }
    try {
      // Remove file from the list front end
      await store.dispatch('removeFileEditedAppointment', fileData.file_pos)
      console.log(store.getters.getEditedAppointmentFiles)
      notyf.success($t('FilesData.NotyfFileRemoved'))
    } catch (e) {
      notyf.error($t('FilesData.NotyfErrorRemoveFile'))
    }
  }
}

function formatFileSize(size: number) {
  if (size < 1024) return `${size} B`;
  if (size < 1048576) return `${(size / 1024).toFixed(1)} KB`;
  return `${(size / 1048576).toFixed(1)} MB`;
}

onMounted(() => {
  console.log("Mounted AppointmentDataFileTableRow")

})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("td", _hoisted_1, [
      _createElementVNode("a", {
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (downloadFile(__props.fileData.download_url, __props.fileData.file_name)), ["prevent"])),
        target: "_blank"
      }, _toDisplayString(__props.fileData.file_name), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.fileData.file_description), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.fileData.file_type), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(formatFileSize(__props.fileData.file_size)), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", null, _toDisplayString(__props.fileData.upload_time), 1)
    ]),
    _createElementVNode("td", null, [
      _createElementVNode("div", _hoisted_2, [
        (editingAppointment())
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("button", {
                type: "button",
                class: "button is-danger is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (remove(__props.fileData, _ctx.$t)))
              }, "Delete")
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ], 64))
}
}

})